import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import { ThemeProvider } from './contexts/ThemeContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { AuthProvider } from './contexts/AuthContext';
import { Toaster } from 'sonner';
import LoginPage from './components/LoginPage';
import Home from './pages/Home';
import ServiceMapperPage from './pages/ServiceMapperPage';
import SoftwarePage from './pages/SoftwarePage';
import HardwarePage from './pages/HardwarePage';
import IncidentPage from './pages/IncidentPage';
import AIAssistantPage from './pages/AIAssistantPage';
import ScopeDashboardPage from './pages/ScopeDashboardPage';
// SSO/OIDC disable logic removed. AppRouter always uses MSAL authentication for app access.
function AppRouter() {
  return (
    <>
      <UnauthenticatedTemplate>
        <LoginPage />
      </UnauthenticatedTemplate>
      <AuthenticatedTemplate>
        <Routes>
          <Route path="/" element={<Navigate to="/service-mapper" replace />} />
          <Route path="/home" element={<Home />} />
          <Route path="/service-mapper" element={<ServiceMapperPage />} />
          <Route path="/software" element={<SoftwarePage />} />
          <Route path="/hardware" element={<HardwarePage />} />
          <Route path="/incidents" element={<IncidentPage />} />
          <Route path="/ai-assistant" element={<AIAssistantPage />} />
          <Route path="/dashboard" element={<ScopeDashboardPage />} />
          <Route path="*" element={<Navigate to="/service-mapper" replace />} />
        </Routes>
      </AuthenticatedTemplate>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ThemeProvider>
          <NotificationProvider>
            <AppRouter />
            <Toaster position="top-center" />
          </NotificationProvider>
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
